<template>
    <div class="top-bar">
        <div class="top-bar-profile">
            <div class="wrapper-logo">
                <div class="icon-sidebar" @click="clickMenu(true)">
                    <img src="../../../assets/icon/navbar_icon_menu.svg" class="img-fluid">
                </div>
                <div class="main-logo">
                    <img :src="$store.getters.getLogoBioderma" alt="" class="img-fluid">
                </div>
                <div class="right-logo">
                    <img :src="$store.getters.getLogoNao" alt="" class="img-fluid">
                </div>
            </div>
            <div class="wrapper-profile">
                <div class="profile-img">
                    <img :src="getPictureLine()" v-if="getPictureLine() && isLogin">
                    <img src="../../../assets/icon/profile-user.svg" v-if="!isLogin">
                </div>
                <!-- login -->
                <div class="profile-point" v-if="isLogin">
                    <div class="text-all-point">
                        <p>{{lbl.topbar.text_all_point}} <span>{{$store.getters.getFormatted}}</span></p>
                        <img src="../../../assets/icon/reward_icon_coin.png">
                    </div>
                    <div class="text-expire-point"
                        :class="{'text-point-gray' :textGrayColor}" v-html="expirePointDate">
                    </div>
                </div>
                <!-- skip login -->
                <div class="profile-point" v-if="!isLogin">
                    <div class="text-all-point" >
                        <p>{{lbl.topbar.text_login}}</p>
                    </div>
                    <div class="btn-login" @click="clickLogin()">
                        <button>{{lbl.topbar.text_btn_login}}</button>
                    </div>
                </div>
            </div>
        </div>

        <SideBar
            @clickMenu="clickMenu"
            :isShowSideBar="isShowSideBar"
            :expirePointDate="expirePointDate">
        </SideBar>
    </div>
</template>
<script>
//helper
import Account from "@/helper/AccountHelper.js";
import Util from "@/helper/Utility.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
//Mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//components
import SideBar from "@/components/Layout/SideBar/SideBar.vue";

export default {
    name: 'TopBar',
    mixins: [AccountMixin, LocaleMixin],
    components: {
        SideBar,
    },
    props: {
        activeTab: String,
        isGray: Boolean,
        tracking: Object,
    },
    data: function() {
        return {
            textGrayColor: false,
            isShowSideBar: false,
            profileImg: null,
            userPoint: 0,
            expirePoint: 0,
            expirePointDate: null,
        };
    },
    created: function () {
        this.profileImg = this.getPictureLine();
        if(this.isGray){
            this.textGrayColor = this.isGray;
        }
    },
    methods: {
        //mixin
        accountInitiated: function () {
            this.getPoint();
            this.getExpirePoint();
            console.log('login status: ',this.isLogin);
        },
        //method
        getPoint: function(){
            Account.apiGetPoint().then((data) =>{
                console.log("point", data.points);
                this.userPoint = data.points;

                this.$store.commit("setPoint", data);
            });
        },
        getExpirePoint: function(){
            Account.apiGetExpiringPoint().then((data) =>{
                console.log('res', data.expiring_points)
                this.expirePoint =  Util.formatNum(data.expiring_points.points);
                this.expirePointDate =  DatetimeHelper.dateShortFormat(data.expiring_points.time);
                this.expirePointDate = this.displayTextPoint();
            });
        },
        displayTextPoint: function(){
            if(!this.expirePointDate) return;
            else return Util.stringFormat(this.lbl.topbar.text_expire_point, this.expirePoint, this.expirePointDate);
        },
        clickMenu: function(isShowSideBar){
           var body = document.querySelector('body');

           if(isShowSideBar){
               body.classList.add('body-noscroll');
           }else{
               body.classList.remove('body-noscroll');
           }

           this.isShowSideBar = isShowSideBar;
           this.tracking.event('side_menu','click_side_menu');

        },
        clickLogin: function(){
            window.location.replace("/linelogin");
        },
        goto(page) {
            this.$router.push('/' + page);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/baseDisplay.scss";
    @import "./TopBar.scss";
</style>
